import React from 'react'

const Link = ({ children }) => (children)

Link.propTypes = {}

Link.propDefault = {}

export default Link



// WEBPACK FOOTER //
// ./src/routes/Link.js